import styled from 'styled-components';
import mediaQuery from 'styles/mediaQuery';

export const PropertySettingsLink = styled.a`
  display: flex;
  align-items: center;
  gap: 5px;

  ${mediaQuery.xs} {
    align-self: end;
  }
`;
